export default __webpack_public_path__ + "static/media/ngo.9296631d.svg";